import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./TheWirePage.css"; // we’ll add styles next
import PostComposer from "./PostComposer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { collection, onSnapshot, query, orderBy, limit } from "firebase/firestore";
import { db, auth } from "../firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import PostCard from "./PostCard";
import ReactDOM from "react-dom";
import PageInfoButton from "../components/PageInfoButton";
import {
  getEngagementScore,
  getTrendingScore,
  isPostExpired,
} from "../utils/postLifecycle";





const TheWirePage = () => {
  const [activeTab, setActiveTab] = useState("latest");
  const [isMobile, setIsMobile] = useState(false);
  const [isLandscape, setIsLandscape] = useState(false);
  const [feedPosts, setFeedPosts] = useState([]);
  const [posts, setPosts] = useState([]);
  const [trendingPosts, setTrendingPosts] = useState([]);
  const [showComposerModal, setShowComposerModal] = useState(false);
  const [nowMs, setNowMs] = useState(() => Date.now());
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();


  const navigate = useNavigate();   // ✅ ← add this here

  // Detect screen size for responsive toggle
  useEffect(() => {
    const handleRecalc = () => {
      setIsMobile(window.innerWidth < 900);
      setIsLandscape(window.innerWidth > window.innerHeight);
    };
    handleRecalc();
    window.addEventListener("resize", handleRecalc);
    window.addEventListener("orientationchange", handleRecalc);
    return () => {
      window.removeEventListener("resize", handleRecalc);
      window.removeEventListener("orientationchange", handleRecalc);
    };
  }, []);

  useEffect(() => {
    const timerId = window.setInterval(() => {
      setNowMs(Date.now());
    }, 60 * 1000);

    return () => window.clearInterval(timerId);
  }, []);



  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAdmin(false);
        return;
      }
      try {
        const tokenResult = await user.getIdTokenResult();
        setIsAdmin(tokenResult.claims?.admin === true);
      } catch (err) {
        console.error("Failed to read admin claim:", err);
        setIsAdmin(false);
      }
    });
    return () => unsubscribe();
  }, []);

	const AdminTab = () => {
  const navigate = useNavigate();

  if (!isAdmin) return null;

  return (
    <button
      className={`wire-tab ${window.location.pathname === "/moderation" ? "active" : ""}`}
      onClick={() => navigate("/moderation")}
    >
      🛠️ Moderation
    </button>
  );
};


useEffect(() => {
  const q = query(
    collection(db, "posts"),
    orderBy("createdAt", "desc"),
    limit(200)
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    setFeedPosts(snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })));
  });

  return () => unsubscribe();
}, []);

useEffect(() => {
  const visiblePosts = feedPosts
    .filter((post) => !post.isHidden && !isPostExpired(post, nowMs))
    .map((post) => ({
      ...post,
      engagementScore: getEngagementScore(post),
      trendingScore: getTrendingScore(post, nowMs),
    }));

  setPosts(visiblePosts.slice(0, 50));
  setTrendingPosts(
    [...visiblePosts]
      .sort((a, b) => {
        if (b.trendingScore !== a.trendingScore) {
          return b.trendingScore - a.trendingScore;
        }
        if (b.engagementScore !== a.engagementScore) {
          return b.engagementScore - a.engagementScore;
        }
        return 0;
      })
      .slice(0, 15)
  );
}, [feedPosts, nowMs]);
  const showMobilePortraitUI = isMobile && !isLandscape;
// Scroll to targeted post (hash) after posts load
useEffect(() => {
  const hash = (location.hash || "").replace(/^#/, "");
  if (!hash || posts.length === 0) return;

  const tryScroll = (attempt = 0) => {
    const el = document.getElementById(hash);
    if (el) {
      const header = document.querySelector('.thewire-header');
      const headerH = header ? header.offsetHeight : 0;
      const rectTop = el.getBoundingClientRect().top + window.pageYOffset;
      const top = Math.max(0, rectTop - headerH - 8);
      window.scrollTo({ top, behavior: 'smooth' });
      return;
    }
    if (attempt < 10) setTimeout(() => tryScroll(attempt + 1), 100);
  };

  // Delay a tick for layout/imagery to settle
  setTimeout(() => tryScroll(0), 50);
}, [location.hash, posts]);




  return (
    <div className="thewire-container">
    <ToastContainer />
    <div className="page-info-header-block" style={{ marginTop: '12px' }}>
      <h2 style={{ margin: 0, fontSize: '28px', textAlign: 'center' }}>The Wire</h2>
      <div className="page-info-button-wrapper">
        <PageInfoButton title="About The Wire">
          <p>The Wire is the live feed for vetted announcements, lessons learned, and community intel.</p>
       <ul className="page-info-list">
  <li>
    <strong>Latest vs Trending:</strong>  
    The <u>Latest</u> column displays posts in chronological order with the newest at the top.  
    The <u>Trending</u> column highlights the most active and popular posts based on overall engagement.
  </li>

  <li>
    <strong>Share:</strong>  
    Tap <u>“Share your thoughts”</u> to create a post.  
    You may include an optional topic, attach links, and upload photos.
  </li>

  <li>
    <strong>Privacy tier:</strong>  
    Choose how your name appears on your posts:  
    full details (rank + name + agency), name + agency, agency only, or anonymous.  
    To prevent abuse, the anonymous option can be used once per week for posts,  
    and once per day for comments.  
    Anonymous posting exists to support sensitive discussions—please use it respectfully.
  </li>

  <li>
    <strong>My Network:</strong>  
    The <u>My Network</u> tab helps you follow other users (👥) and keep up with their posts.  
    Select a user to view their recent activity in one place and interact with their content  
    (read, like, and comment).
  </li>

  <li>
    <strong>My Activity:</strong>  
    The <u>My Activity</u> tab displays your own posts.  
    You can review, edit, or delete them at any time.
  </li>

  <li>
    <strong>Engage safely:</strong>  
    Tap any post card to open the full discussion thread and participate in the conversation.
  </li>
</ul>

        </PageInfoButton>
      </div>
    </div>
   <header className="thewire-header">
  <div className="wire-tabs">
   

    {auth.currentUser && (
      <>
        <button
          className={`wire-tab ${window.location.pathname === "/mynetwork" ? "active" : ""}`}
          onClick={() => navigate("/mynetwork")}
        >
          👥 My Network
        </button>

        <button
          className={`wire-tab ${window.location.pathname === "/myactivity" ? "active" : ""}`}
          onClick={() => navigate("/myactivity")}
        >
          📊 My Activity
        </button>
      </>
    )}

    <AdminTab />
  </div>
</header>

{/* ✅ Mobile-only toggle now lives BELOW the header */}
{showMobilePortraitUI && (
  <div className="thewire-toggle-wrapper">
    <div className="thewire-toggle">
      <button
        className={activeTab === "latest" ? "active" : ""}
        onClick={() => setActiveTab("latest")}
      >
        Latest
      </button>
      <button
        className={activeTab === "trending" ? "active" : ""}
        onClick={() => setActiveTab("trending")}
      >
        Trending
      </button>
    </div>
  </div>
)}



      <main className={`thewire-content ${showMobilePortraitUI ? "mobile" : "desktop"}`}>
        {/* Desktop layout: 2 columns */}
        {!showMobilePortraitUI && (
          <>
            <div className="column latest-column">
              <h2>Latest Posts</h2>
            <div className="posts-list">
  {posts.length === 0 ? (
    <div className="post-placeholder">No posts yet.</div>
  ) : (
    posts.map((post) => (
      <PostCard
        key={post.id}
        post={post}
        showScore={false}
        anchorId={`post-${post.id}`}
        isAdmin={isAdmin}
      />
    ))
  )}
</div>
            </div>

          <div className="column trending-column">
  <h2>Trending</h2>
  <div className="posts-list">
    {trendingPosts.length === 0 ? (
      <div className="post-placeholder">No trending posts yet.</div>
    ) : (
      trendingPosts.map((post) => (
        <PostCard key={post.id} post={post} showScore isAdmin={isAdmin} />
      ))
    )}
  </div>
</div>
          </>
        )}

        {/* Mobile portrait layout: toggled sections */}
       {showMobilePortraitUI && (
  <div className="mobile-column">
    {activeTab === "latest" && (
      <div className="posts-list">
        {posts.length === 0 ? (
          <div className="post-placeholder">No posts yet.</div>
        ) : (
          posts.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              showScore={false}
              anchorId={`post-${post.id}`}
              isAdmin={isAdmin}
            />
          ))
        )}
      </div>
    )}

   {activeTab === "trending" && (
  <div className="posts-list">
    {trendingPosts.length === 0 ? (
      <div className="post-placeholder">No trending posts yet.</div>
    ) : (
      trendingPosts.map((post) => (
        <PostCard key={post.id} post={post} showScore isAdmin={isAdmin} />
      ))
    )}
  </div>
)}
  </div>
)}
      </main>

      {/* Inline composer placeholder */}
   <footer className="composer-section">
  <button
    className="share-button"
    onClick={() => setShowComposerModal(true)}
  >
    💬 Share Your Thoughts
  </button>

{showComposerModal &&
  ReactDOM.createPortal(
    <div className="composer-modal-overlay" onClick={() => setShowComposerModal(false)}>
      <div
        className="composer-modal"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      >
        <button className="close-modal" onClick={() => setShowComposerModal(false)}>✖</button>
       <PostComposer
  onSubmit={(newPost) => {
    console.log("📝 New Post:", newPost);
    setShowComposerModal(false); // close immediately
    document.body.style.overflow = "auto"; // ensure scrolling restored
  }}
  onPostSuccess={() => setShowComposerModal(false)} // ✅ extra safety
/>
      </div>
    </div>,
    document.body
  )}

</footer>

    </div>
  );
};

export default TheWirePage;
